const keepKeys = (object, keyWhitelist) =>
  keyWhitelist.reduce((acc, key) => {
    if (typeof object[key] !== 'undefined') {
      acc[key] = object[key];
    }
    return acc;
  }, {});

module.exports = keepKeys;
